import React from 'react';

const FormatDateTime = ({ isoDateString }) => {
  const formatDateAndTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <div>
      {formatDateAndTime(isoDateString)}
    </div>
  );
};

export default FormatDateTime;
